<!-- 
    FORM PARA DEFINICAO DO MOTIVO DA PERDA
-->

<script>
import Vue from 'vue';
import { SysVars } from '../main';
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        params: {},
    },
    
    components: {
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            negociocrm: {...this.$store.getters.getEntities.negociocrm},

            inputMotivo: {
                url: '/crm/find/motivo?descricao=',
                permite_novo: false,
                codigo: null,
                label: 'Motivo da Perda',
                // icon: 'fa-university', 
            },
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        title: function () {
            return 'Negócio Perdido'
        },
        administrador: function () {
            return SysVars.usuarioAdministrador
        },
    },

    methods: {
        handleSalvar () {
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.negociocrm.dados = { 
                        motivo: this.motivo,
                    }
                    this.apiNegocio(this.negociocrm, this.negociocrm.codnegocio, this.callBackPost)
                }
            })

        },

        handleCadastroMotivo () {
            this.$router.push('/crm/config')
        },

        callBackPost (negocio) {
            this.closeForm(negocio)
        },

        closeForm (negocio) {
            this.$emit('closeform', negocio)
        },

        handleNovoMotivo (text) {
            this.motivo = { novo: true, descricao: text }
        },

        handleSelectMotivo (selected) {
            this.motivo = selected
            if (this.motivo) {
                this.motivo.novo = false
            }
        },

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.motivo) {
                this.$refs.motivo.focus()
            }
        })
    },

    created () {
        if (this.params.negocio) {
           this.negociocrm = this.params.negocio
        }
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; min-width: 500px; max-width: 100%">
            <div class="nb-modal-header">
                <div class="row">
                    <div class="col-md-12 col-12">
                        <h4 class="def-title"> Motivo da Perda </h4>
                    </div>
                </div>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <form-field v-model="negociocrm.codmotivo" type="select2" col="12" 
                        :metadata="metadata.negociocrm.codmotivo">
                        <a v-if="administrador" style="cursor: pointer; color: #0091ea;" @click="handleCadastroMotivo">Acesso ao cadastro de motivos</a>
                    </form-field>
                    
                    <!-- <div class="col-md-12">
                        <input-search ref="motivo" v-model="negociocrm.codmotivo" @novo="handleNovoMotivo" @select="handleSelectMotivo" :params="inputMotivo" :metadata="metadata.negociocrm.codmotivo"></input-search>
                    </div>
                    <div class="col-12">
                    </div> -->
                </div>

                <div class="row mt-2 mb-5">
                    <form-field v-model="negociocrm.textomotivo" type="memo" col="12" :metadata="metadata.negociocrm.textomotivo"
                        name="textomotivo" :v-errors="errors" v-validate="metadata.negociocrm.textomotivo.validator"></form-field>
                </div>
            </div>
            <div class="modal-footer">
                <v-button label="Cancelar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                <v-button label="Confirmar Como Perdido" title="" :danger="true" @click="handleSalvar"></v-button>
            </div>
        </div>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-negocio-motivo-form.vue